export default __webpack_public_path__ + "scene5_1_icon16f32f.png";